export enum ProspectsListTableColumnId {
  AddedBy = "addedBy",
  Approved = "approved",
  EstimatedTicketSizeMax = "estimatedTicketSizeMax",
  EstimatedTicketSizeMin = "estimatedTicketSizeMin",
  IcgPriority = "icgPriority",
  LimitedPartner = "limitedPartner",
  LpSma = "lpSma",
  Notes = "notes",
  OrganizationChannel = "organizationChannel",
  ProbabilityWeightedMidPoint = "probabilityWeightedMidPoint",
  Actions = "actions",
  Tier = "tier",
}
